import { Component, Output, Input, ElementRef } from '@angular/core';
import { EventEmitter } from '@angular/core';
import { environment } from 'src/environments/environment';
import { ViewChild } from '@angular/core';
import { ToastrMessageServiceService } from '../../services/toastr-message/toastr-message-service.service';
import { marker as _ } from '@biesbjerg/ngx-translate-extract-marker';

@Component({
  selector: 'app-image-upload',
  templateUrl: './image-upload.component.html',
  styleUrls: ['./image-upload.component.scss']
})
export class ImageUploadComponent {
  @Input() image: any;
  @Input() isLoading = false;
  @Input() canAdd = true;
  @Input() canRemove = false;
  @Input() isDisabled: boolean;
  @Input() isLogo = false;
  @Input() defaultImgPath: string;
  @Input() centered: boolean;

  @Output() newImageAdded: EventEmitter<string> = new EventEmitter();
  @Output() newImageRemoved: EventEmitter<any> = new EventEmitter();
  @Output() imageChangedEvent: EventEmitter<any> = new EventEmitter();

  @ViewChild('file')
  fileElement: ElementRef;

  file: File;
  message: string;
  byteToMbConversionRate: number = 1024 * 1024;
  maxFileSize: string;
  showCropper: boolean;

  id: string = 'image-upload-' + new Date().toISOString();
  validImageFormatsMsg: string = _('image-upload.toastr-messages.valid-image-formats');

  constructor(private toastrMessageServiceService: ToastrMessageServiceService) {
    this.maxFileSize = `${environment.maxImageSize} MB`;
  }

  imageSelected(files) {
    if (files.length === 0) {
      return;
    }

    const mimeType = files[0].type;
    if (mimeType.match(/image\/png|image\/jpg|image\/jpeg/) == null) {
      this.toastrMessageServiceService.warning(this.validImageFormatsMsg);
      return;
    }

    this.file = files[0];
    this.showCropper = true;
  }

  removeImage() {
    this.newImageRemoved.emit(true);
  }

  uploadDraftImage(croppedFile: string) {
    this.newImageAdded.emit(croppedFile);
    this.file = null;
    this.showCropper = false;
  }

  cancel() {
    this.fileElement.nativeElement.value = '';
    this.showCropper = false;
  }

  onImgError(event) {
    this.image = null;
  }
}
